module.exports = __webpack_public_path__ + "img/左边背景.18af0bb8.png";